import React from 'react'
import './BaseModal.css'

function BaseModal(props) {

    const [internalShow, setInternalShow] = React.useState(false);
    const [classShow, setClassShow] = React.useState(false);

    React.useEffect(() => {
        if (props.show == true) {
            setInternalShow(true);
            setTimeout(() => {
                setClassShow(true);
            }, 500);
        } else {
            if (internalShow == true) {
                setClassShow(false);
                setTimeout(() => {
                    setInternalShow(false);
                }, 500);
            }
        }

    }, [props.show]);

    return (
        <>
            <div id="myModal" className={props.className + " modal fade " + (classShow == true ? 'show' : '')} style={{ display: (internalShow == true ? 'block' : 'none') }}
                aria-modal="true">
                <div className="modal-dialog modal-confirm" style={{ position: "relative", top: "calc(50% - 300px)" }}>
                    <div className="modal-content">
                        <div className="modal-header">
                            <div className="icon-box">
                                <div className={'modal-icon ' + (classShow == true ? 'icon-activate' : '')}>{props.icon}</div>
                            </div>
                            <h4 className="modal-title w-100">{props.title}</h4>
                        </div>
                        <div className="modal-body">
                            {props.children}
                        </div>
                        <div className="modal-footer">
                            <button className="btn w-100" data-dismiss="modal" onClick={() => { props.onButtonClick(); }}>{props.buttonText}</button>
                        </div>
                    </div>
                </div>
            </div>
            <div className={"modal-backdrop fade " + (classShow == true ? 'show' : '')} style={{ display: (internalShow == true ? 'block' : 'none') }}></div>
        </>
    )
}


export default BaseModal